const calendarServiceCard = {
  schedule: 'Agendar',
  scheduledDate: 'Fecha agendada',
  scheduledTo: 'Agendado para',
  scheduled: 'Agendado',
};

export default calendarServiceCard;
